import { useNfe } from "@contexts/nfe";
import { NFCe } from "@models/nfce/NFCe";
import { DANFE } from "@models/NFe";

interface NfeTabProps {
    activeNFe: NFCe
    editMode: boolean
}

export function AdditionalInfoTab({ activeNFe, editMode }: NfeTabProps) {

    const {editedNfe, updateEditedNfe} = useNfe();

    const onChange = (field: string, value: string) => {
        updateEditedNfe({...editedNfe, [field]: value})
    }

    return <>
        <aside className={['bottom-frame', 'edit-border', 'visible'].join(' ')}>
            <div className="content">
                <div style={{ display: 'flex', width: '100%', marginTop: 10, marginBottom: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '100%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Formato de Impressão DANFE</span>
                        <input type="text" disabled value={activeNFe.infNfe?.ide?.tpImp && DANFE[activeNFe.infNfe?.ide?.tpImp]} />
                    </div>
                </div>
            </div>
        </aside>
        <aside className={['bottom-frame', 'edit-border', 'visible'].join(' ')} style={{ marginTop: 10 }}>
            <span className="header">Informações Complementares de Interesse do Contribuinte</span>

            <div className="content">
                <div style={{ display: 'flex', width: '100%', marginTop: 10, marginBottom: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '100%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>Descrição</span>
                        <textarea disabled={!editMode} value={editedNfe?.infCpl ?? activeNFe?.infNfe?.infAdic?.infCpl ?? ""} style={{height: '50px'}} onChange={e => onChange("infCpl", e.target.value)}/>
                    </div>
                </div>
            </div>
        </aside>
        <aside className={['bottom-frame', 'edit-border', 'visible'].join(' ')} style={{ marginTop: 10 }}>
            <span className="header">Informações Suplementares</span>

            <div className="content">
                <div style={{ display: 'flex', width: '100%', marginTop: 10, marginBottom: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '100%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>QR-Code</span>
                        <input type="text" disabled value={activeNFe?.infNFeSupl?.qrCode ?? ""}  />
                    </div>
                </div>
                <div style={{ display: 'flex', width: '100%', marginTop: 10, marginBottom: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: '15px', width: '100%' }}>
                        <span className="input-label" style={{ whiteSpace: 'nowrap' }}>URL NFC-e</span>
                        <input type="text" disabled value={activeNFe?.infNFeSupl?.urlChave ?? ""} />
                    </div>
                </div>
            </div>
        </aside>
    </>;
}